<modal>
  <span header class="uppercase">{{'Đơn nhập xưởng mã' | lang}} {{SKU}} <span *ngIf="color">{{'màu' | lang}} {{color}}</span> ({{range.name}})</span>

  <text-filter [target]="details" class="std-margin-bottom" [placeholder]="'Tìm đơn'"></text-filter>

  <table responsive class="data">
    <tr>
      <th priority="6" class="text-top text-right" style="width: 0">STT</th>
      <th priority="1" class="text-top"><sortable [target]="details" [extractor]="extractor('Tag')">{{'Đơn nhập' | lang}}</sortable></th>
      <th priority="3" class="text-top text-right"><sortable [target]="details" [extractor]="extractor('LengthQuantity')">{{'Hàng mét' | lang}}</sortable></th>
      <th priority="5" class="text-top text-right"><sortable [target]="details" [extractor]="extractor('WeightQuantity')">{{'Hàng cân' | lang}}</sortable></th>
      <th priority="5" class="text-top text-right"><sortable [target]="details" [extractor]="extractor('ReducedQuantity')">{{'Khấu trừ' | lang}}</sortable></th>
      <th priority="4" class="text-top text-right"><sortable [target]="details" [extractor]="extractor('QuoteQuantity')">{{'Tính tiền' | lang}}</sortable></th>
      <th priority="4" class="text-top text-right"><sortable [target]="details" [extractor]="extractor('Price')">{{'Giá nhập' | lang}}</sortable></th>
      <th priority="2" class="text-top text-right"><sortable [target]="details" [extractor]="extractor('Subtotal')">{{'Thành tiền' | lang}}</sortable></th>
    </tr>
    <tr *ngFor="let i of details.pageMatches; index as ix" class="text-top">
      <td><small>{{ix + 1 + details.pageIndex * details.pageSize}}</small></td>
      <td>
        <invoice [tag]="i.Path[0]" [displays]="{partner: true}" (unconfirmed)="unconfirmed($event)" [filters]="{ sku: SKU, color: color, importTag: i.Path[0] }"></invoice>
      </td>
      <td>
        <div><span class="text-danger">{{i.Imports.LengthQuantity - i.ProviderLosses.LengthQuantity | number : '1.1-1' : 'en-US'}}</span><m></m></div>
        <small><b class="text-danger">{{i.Imports.LengthCount - i.ProviderLosses.LengthCount | number : '1.0-0' : 'en-US'}}</b><unit>cây</unit></small>
      </td>
      <td>
        <div><span class="text-danger">{{i.Imports.WeightQuantity - i.ProviderLosses.WeightQuantity | number : '1.1-1' : 'en-US'}}</span><kg></kg></div>
        <small><b class="text-danger">{{i.Imports.WeightCount - i.ProviderLosses.WeightCount | number : '1.0-0' : 'en-US'}}</b><unit>cây</unit></small>
      </td>
      <td>
        <div><span class="text-success">{{i.Imports.LengthQuantity - i.ProviderLosses.LengthQuantity - (i.Imports.LengthQuoteQuantity - i.ProviderLosses.LengthQuoteQuantity) | number : '1.1-1' : 'en-US'}}</span><m></m></div>
        <div><span class="text-success">{{i.Imports.WeightQuantity - i.ProviderLosses.WeightQuantity - (i.Imports.WeightQuoteQuantity - i.ProviderLosses.WeightQuoteQuantity) | number : '1.1-1' : 'en-US'}}</span><kg></kg></div>
      </td>
      <td>
        <div><span class="text-danger">{{i.Imports.LengthQuoteQuantity - i.ProviderLosses.LengthQuoteQuantity | number : '1.1-1' : 'en-US'}}</span><m></m></div>
        <div><span class="text-danger">{{i.Imports.WeightQuoteQuantity - i.ProviderLosses.WeightQuoteQuantity | number : '1.1-1' : 'en-US'}}</span><kg></kg></div>
      </td>
      <td>
        {{i.Imports.BaseWorth / (i.Imports.LengthQuoteQuantity + i.Imports.WeightQuoteQuantity) | number : '1.1-1' : 'en-US'}}
        <cny-per-unit [type]="i.Imports.LengthCount > 0 ? (i.Imports.WeightCount > 0 ? 0 : 1) : 2"></cny-per-unit>
      </td>
      <td>
        <b class="text-danger">{{i.Imports.BaseWorth - i.ProviderLosses.BaseWorth | number : '1.1-1' : 'en-US'}}</b><cny></cny>
        <div class="small" *ngIf="i.ProviderLosses.BaseWorth > 0">
          {{i.Imports.BaseWorth | number : '1.0-1' : 'en-US'}} - <span class="text-danger">{{i.ProviderLosses.BaseWorth | number : '1.1-1' : 'en-US'}}</span>
        </div>
      </td>
    </tr>

    <tr *ngIf="details.pages.length > 1">
      <td [colSpan]="8" style="display: table-cell !important" class="text-center"><pagination [target]="details"></pagination></td>
    </tr>

    <tr class="footer bold" *ngIf="details.matches.length > 1">
      <td></td>
      <td>{{'TỔNG' | lang}} ({{details.matches.length}})</td>
      <td>
        <div><b>{{sum('LengthQuantity') | number : '1.1-1' : 'en-US'}}</b><m></m></div>
        <small>{{sum('LengthCount') | number : '1.0-0' : 'en-US'}}<unit>{{'cây' | lang}}</unit></small>
      </td>
      <td>
        <div><b>{{sum('WeightQuantity') | number : '1.1-1' : 'en-US'}}</b><kg></kg></div>
        <small>{{sum('WeightCount') | number : '1.0-0' : 'en-US'}}<unit>{{'cây' | lang}}</unit></small>
      </td>
      <td>
        <div><b>{{sum('ReducedLength') | number : '1.1-1' : 'en-US'}}</b><m></m></div>
        <div><b>{{sum('ReducedWeight') | number : '1.1-1' : 'en-US'}}</b><kg></kg></div>
      </td>
      <td>
        <div>{{sum('QuoteLength') | number : '1.1-1' : 'en-US'}}<m></m></div>
        <div>{{sum('QuoteWeight') | number : '1.1-1' : 'en-US'}}<kg></kg></div>
      </td>
      <td>
        {{sum('Subtotal') / (sum('QuoteLength') + sum('QuoteWeight')) | number : '1.1-1' : 'en-US'}}
        <cny-per-unit [type]="sum('LengthCount') > 0 ? (sum('WeightCount') > 0 ? 0 : 1) : 2"></cny-per-unit>
      </td>
      <td>{{sum('Subtotal') | number : '1.1-1' : 'en-US'}}<cny></cny></td>
    </tr>
  </table>
</modal>
